import { render, staticRenderFns } from "./SchoolSelector.vue?vue&type=template&id=e029ed10&scoped=true&"
import script from "./SchoolSelector.vue?vue&type=script&lang=js&"
export * from "./SchoolSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e029ed10",
  null
  
)

export default component.exports